import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appPlainTextOnly]'
})
export class PlainTextOnlyDirective {

  constructor(private el: ElementRef) { }

  // Listen to paste event and prevent default behavior
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const text = event.clipboardData?.getData('text/plain');
    document.execCommand('insertText', false, text);
  }

  // Listen to keydown event and add <p> tag to new paragraphs
  @HostListener('keydown.enter', ['$event'])
  onEnterKeyDown(event: KeyboardEvent) {
    const selection = window.getSelection();
    const range = selection?.getRangeAt(0);
    const textNode = range?.startContainer;
    const parentNode = textNode?.parentNode;

    if (parentNode?.nodeName === 'DIV') {
      event.preventDefault();
      const newP = document.createElement('p');
      newP.innerHTML = '&#8203;';
      parentNode.insertBefore(newP, textNode.nextSibling);
      range?.setStart(newP, 0);
      range?.setEnd(newP, 0);
      selection?.removeAllRanges();
      selection?.addRange(range);
    }
  }

}
